<template>
  <div v-if="userCountry !== ''">
    <div v-if="countries[userCountry]">
      <component
        :is="countries[userCountry].page"
        :data="countries[userCountry].data"
      ></component>
    </div>
    <div v-else>Invalid country</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import countryOptions from './payretailers-options'

export default {
  data() {
    return {
      userCountry: '',
      countries: countryOptions,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
    }),
  },
  mounted() {
    this.$bus.$on('requestPRWithdraw', this.requestWithdraw)

    this.userCountry = this.User.info.country_code
  },
  beforeDestroy() {
    this.$bus.$off('requestPRWithdraw', this.requestWithdraw)
  },
  methods: {
    requestWithdraw(data = null) {
      if (data) {
        data.country_code = this.userCountry
        this.$bus.$emit('request', data)
      } else {
        this.$toasted.error('Unable to send request: No payment data')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// mulix-payretailers.vue?0e1e4809